import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ScrollToTop' })((theme) => ({
  paper: {
    backgroundColor: theme.palette.primary.main,
    position: 'fixed',
    bottom: 30,
    right: 30,
    height: 40,
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  chevron: {
    color: theme.palette.primary.contrastText,
  },
}));

export default useStyles;
